export const feesConstants = {
	SEND_FEES_SUCCESS: "SEND_FEES_SUCCESS",
	SEND_FEES_ERROR: "SEND_FEES_ERROR",
	SEND_FEES_REQUEST: "SEND_FEES_REQUEST",

	SET_FEE_PROGRAM: "SET_FEE_PROGRAM",
	SET_FEE_VALUE: "SET_FEE_VALUE",
	SET_ADDITIONAL_FEE_VALUE: "SET_ADDITIONAL_FEE_VALUE",
	SET_MONTHLY_FEE_VALUE: "SET_MONTHLY_FEE_VALUE",
};
